import * as React from "react";

import "./alert-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";


export const AlertModal = ({ next: rootNext=()=>null, initShow=false, header="", message, okCallback=()=>null, cancelButton=true, cancelCallback=()=>null, xdQaName="alertModal" }) => cs(
    ["modal", ({}, next) => ModalService3({
        next: ({close}) => next({close}),
        initShow,
        xToClose: true,
        ignorePassiveClose: true,
        rootNext,
        contentClassName: 'alert-modal-897',
        xdQaName: xdQaName,
    })],

    ({modal}) => (
        <>
            <div className="header-text-cont">
                <span className="header">{header}</span>
            </div>
            <hr/>
            <div className="message-text-cont">
                <span className="message">{message}</span>
            </div>
            <hr/>
            <div className="ok-and-cancel-buttons-container">
                {cancelButton &&
                    <div className="cancel-button"
                        onClick={() => {
                            cancelCallback();
                            modal.close();
                        }}
                        xd-qa-type="button"
                        xd-qa-name="Cancel"
                    >
                        Cancel
                    </div>
                }
                <div className="ok-button"
                    onClick={() => {
                        okCallback();
                        modal.close();
                    }}
                    xd-qa-type="button"
                    xd-qa-name="OK"
                >
                    OK
                </div>
            </div>
        </>
    )

)